import { render } from "./Skin.vue?vue&type=template&id=4c35faf7"
import script from "./Skin.vue?vue&type=script&lang=js"
export * from "./Skin.vue?vue&type=script&lang=js"
script.render = render

export default script